import { IoLayersOutline } from "react-icons/io5";
import RegionCreateModal from "../Modal/RegionCreateModal";
import RegionListPage from "./RegionListPage";

const columns = [
  { header: "Wing Name", key: "wing" },
  { header: "Wing Id", key: "wingId" },
  { header: "State", key: "state" },
  { header: "Circle", viewKey: "circleList", viewTitle: "Circle List" },
  { header: "Created By", key: "createdBy" },
  { header: "Location Description", key: "locationDescription" },
];

const Wing = () => (
  <RegionListPage
    field="wing"
    label="Wing"
    viewTab="Wing"
    CreateIcon={IoLayersOutline}
    createLabel="Create New Wing"
    columns={columns}
    renderCreate={(p) => (
      <RegionCreateModal
        {...p}
        tab="Wing"
        fieldName1="Wing Name"
        fieldName2="Choose Circle"
      />
    )}
  />
);

export default Wing;